<div class="p-grid pt-2 main-header p-ai-center p-jc-around">
    <!-- logo -->
    <div class="p-col-1">
        <a [routerLink]="['/']">
        <img class="img-fluid" [src]="imgDuminval" />
        </a>
    </div>
    <div class="p-col-2">
        <img class="img-fluid" [src]="imgInterreg">
    </div>
    <div class="p-col-1">
        <img class="img-fluid cencylImg" [src]="imgCencyl" />
    </div>
    <div class="p-col-4 p-d-flex p-jc-end">
        <nav class="navbar navbar-expand-lg navbar-light mt-3" *ngIf="user !== undefined">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item dropdown">
                    <a class="nav-link" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="img-fluid rounded-circle z-depth-0 border border-dark p-3"> {{user.nombre | slice:0:1}}{{user.apellido | slice:0:1}}</span>
                        <span class="ml-1">{{user.usuario}}</span>
                    </a>
                    <div class="dropdown-menu positionAb mt-2" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="area-privada">{{'MENU.USUARIO.AREA.PRIVADA' |translate}}</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="area-privada/editar-usuario">{{'MENU.USUARIO.PERFIL' |translate}}</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="area-privada/gestionar-tus-vehiculos">{{'MENU.USUARIO.MIS.VEHICULOS' |translate}}</a>
                        <div class="dropdown-divider"></div>
                        <div *ngIf="userLogueado && !userLogueado.ldap">
                            <a class="dropdown-item" href="area-privada/cambiar-contrasena">{{'GLOBAL.CAMBIAR.CONTRASENA' | translate}}</a>
                            <div class="dropdown-divider"></div>
                        </div>
                        <a class="dropdown-item" href="area-privada/contactar-soporte">{{'GLOBAL.SOPORTE' | translate}}</a>
                        <div class="dropdown-divider"></div>
                        <span class="dropdown-item span-logout" (click)="logout()">{{'MENU.USUARIO.CERRAR.SESION' |translate}}</span>
                    </div>
                </li>
            </ul>
        </nav>
    </div>
</div>
<div class="delim"></div>
